import request from '@/utils/request'
import baseUrl from '@/api/baseUrl'
import commonJs from '@/utils/common'
export default {
	getVersions(params){
		params = commonJs.obj.removeNullKey(params)
		return request({
			url: baseUrl+'/auth/getVersion',
			method:'get',
			params
		})
	},
	getNodeTree(){
		return request({
			url: baseUrl + '/system/menu/tree',
			method: 'get'
		})
	}
}